<template>
  <div class="pt20">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('admin.content.video.add.back') }}</span>
    </div>
    <h4>
      {{
        id
          ? $t('admin.content.video.add.title.edit', { name: columnTitle })
          : $t('admin.content.video.add.title.create', { name: columnTitle })
      }}
    </h4>
    <a-form :form="form" layout="vertical">
      <div class="list_wrap">
        <div class="list">
          <a-form-item class="full" :label="$t('admin.content.video.add.form.title.label')" :colon="false">
            <a-input
              maxLength="20"
              allowClear
              :placeholder="$t('admin.content.video.add.form.title.placeholder')"
              v-decorator="[
                'title',
                { rules: [{ required: true, message: $t('admin.content.video.add.form.title.required') }] }
              ]"
            ></a-input>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item class="full" :label="$t('admin.content.video.add.form.status.label')" :colon="false">
            <a-select
              allowClear
              v-decorator="[
                'status',
                { rules: [{ required: true, message: $t('admin.content.video.add.form.status.required') }] }
              ]"
              :placeholder="$t('admin.content.video.add.form.status.placeholder')"
            >
              <a-select-option v-for="item in stateList" :key="item.id" :value="item.id">
                {{ $t(`admin.content.video.add.form.status.options.${item.id === 1 ? 'open' : 'closed'}`) }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item class="full" :label="$t('admin.content.video.add.form.video.label')" :colon="false">
            <Upload
              @uploadData="uploadData"
              :fileUrl="form.getFieldValue('videoUrl')"
              :accept="['mp4']"
              coverType="video"
              :desc="$t('admin.content.video.add.form.video.description')"
              v-decorator="[
                'videoUrl',
                { rules: [{ required: true, message: $t('admin.content.video.add.form.video.required') }] }
              ]"
            ></Upload>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item
            class="full recommend"
            :label="$t('admin.content.video.add.form.recommend.label')"
            :colon="false"
          >
            <div v-decorator="['recommend']"></div>
            <a-radio-group class="radioGroup" v-model="recommend" @change="changeRecommend">
              <a-radio :value="false">{{
                $t('admin.content.video.add.form.recommend.options.notRecommended')
              }}</a-radio>
              <a-radio :value="true">{{ $t('admin.content.video.add.form.recommend.options.recommended') }}</a-radio>
            </a-radio-group>
            <a-select
              :placeholder="$t('admin.content.video.add.form.recommend.level.placeholder')"
              v-if="recommend"
              v-model="recommendLevelSelect"
            >
              <a-select-option v-for="item in recommendLevel" :key="item.id" :value="item.id">
                {{ $t(`admin.content.video.add.form.recommend.level.options.level${item.id}`) }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
      </div>

      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('admin.content.video.add.submit') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import Editor from '@/components/Editor/tinymce.vue'
import Upload from '@/components/upload/index.vue'

import { videoSave, videoDetail } from '@/api/admin'
export default {
  components: {
    Editor,
    Upload
  },
  data() {
    return {
      id: undefined,
      stateList: [
        {
          id: 1,
          name: '开启'
        },
        {
          id: 2,
          name: '关闭'
        }
      ],
      recommend: false,
      recommendLevelSelect: 0,
      recommendLevel: [
        {
          id: 1,
          name: '一级'
        },
        {
          id: 2,
          name: '二级'
        },
        {
          id: 3,
          name: '三级'
        },
        {
          id: 4,
          name: '四级'
        },
        {
          id: 5,
          name: '五级'
        },
        {
          id: 6,
          name: '六级'
        },
        {
          id: 7,
          name: '七级'
        },
        {
          id: 8,
          name: '八级'
        },
        {
          id: 9,
          name: '九级'
        },
        {
          id: 10,
          name: '十级'
        }
      ],
      form: this.$form.createForm(this),
      columnTitle: this.$route.query.columnTitle
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    changeRecommend(e) {
      this.recommendLevelSelect = this.recommend ? 1 : 0
    },
    uploadData(data) {
      this.form.setFieldsValue({
        videoUrl: data[0].url
      })
    },
    async handleSubmit(e) {
      e.preventDefault()
      this.form.setFieldsValue({
        recommend: this.recommend ? this.recommendLevelSelect : 0
      })
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const data = Object.assign(values, {
            id: this.id,
            columnId: this.columnId
          })
          const res = await videoSave(data)
          if (res.code === 200) {
            const tip = this.id
              ? this.$t('admin.content.video.add.messages.editSuccess')
              : this.$t('admin.content.video.add.messages.createSuccess')
            this.$message.success(tip)
            this.$router.back()
          }
        }
      })
    },
    async getNewsDetail() {
      const res = await videoDetail({ id: this.id })
      if (res.code == 200) {
        this.form.setFieldsValue({
          videoUrl: res.data.videoUrl,
          title: res.data.title,
          status: res.data.status
        })
        this.recommendLevelSelect = res.data.recommend
        this.recommend = res.data.recommend > 0
      }
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    this.columnId = this.$route.query.columnId || undefined
    if (this.id) {
      this.getNewsDetail()
    }
  }
}
</script>

<style lang="less" scoped>
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
  border-bottom: 1px solid #ededed;
  margin-bottom: 20px;
  padding-bottom: 12px;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form {
  position: relative;
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }
  .list_wrap {
    display: flex;
    padding-right: 12px;
    flex-wrap: wrap;
  }
  .list {
    width: 50%;
    display: flex;
    padding-right: 0px;
    .ant-form-item-label {
      width: 100px;
      label {
        color: #000000;
      }
    }
    .ant-form-item {
      width: 100%;
      padding-left: 6px;
      &:first-child {
        padding-left: 0;
        padding-right: 45px;
      }
    }
    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;
      img {
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div {
      position: relative;
      .ant-calendar-picker-input {
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }
    .ant-input,
    .ant-select {
      border-radius: 4px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }
    .recommend {
      .ant-radio-group {
        display: flex;
        align-items: center;
        .ant-radio-wrapper {
          margin-right: 20px;
          .ant-radio {
            color: #000000;
          }
        }
      }
      .ant-select {
        width: 107px;
        margin-left: 126px;
        border-radius: 4px;
        color: #000000;
        height: 35px;
      }
    }
    .ant-input-wrapper.ant-input-group {
      .ant-input {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon {
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5e7a92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .right {
    position: absolute;
    top: 0;
    left: 50%;
    width: 50%;
  }
  .submit-button {
    width: 100%;
    // padding-left: 500px;
    text-align: center;
  }
}
</style>
